import I18NextChainedBackend from 'i18next-chained-backend';
import type { UserConfig } from 'next-i18next';

import { chainedBackendOptions } from './backendOptions';

type AppName = Parameters<typeof chainedBackendOptions>[0];

/**
 * next-i18next(web·zepx) 설정에 브라우저용 HTTP 백엔드를 얹는다.
 * 서버는 파일에서, 브라우저는 `/locales/{lng}/{ns}.json?version=` 으로 받는다.
 * `appWithTranslation(App, withClientHttpBackend(config, 'web'))` 처럼 쓴다.
 */
export const withClientHttpBackend = (
  config: UserConfig,
  appName: AppName,
): UserConfig =>
  typeof window === 'undefined'
    ? config
    : {
        ...config,
        use: [I18NextChainedBackend],
        backend: chainedBackendOptions(appName),
      };
